import React from "react";
import styled from "@emotion/styled";
import { useStores } from "@stores";
import { observer } from "mobx-react-lite";
import { ASSETS_TYPE } from "@src/constants";
import Text from "@src/components/Text";
import SizedBox from "@components/SizedBox";
import useWindowSize from "@src/hooks/useWindowSize";
import DesktopTable from "@screens/MarketPage/AssetsTable/DesktopTable";
import MobileAssetsTable from "@screens/MarketPage/AssetsTable/MobileAssetsTable";

interface IProps {}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
`;

const AssetsTable: React.FC<IProps> = () => {
  const { width } = useWindowSize();
  const { lendStore } = useStores();

  if (
    width &&
    width < 880 &&
    lendStore.mobileDashboardAssets !== ASSETS_TYPE.HOME
  )
    return null;

  //todo add filter
  return (
    <Root>
      <Text weight={500} size="big" fitContent>
        All Assets
      </Text>
      <SizedBox height={8} />
      {width && width >= 880 ? <DesktopTable /> : <MobileAssetsTable />}
    </Root>
  );
};
export default observer(AssetsTable);
